import React, { Dispatch, SetStateAction, createContext, useState } from 'react'
import { StaticSegmentFormStateType } from '../types/segment'
import { defaultStaticSegmentFormState } from 'src/assets/SegmentsConfig'

interface SegmentContextType {
  segmentFormState: StaticSegmentFormStateType
  setSegmentFormState: Dispatch<SetStateAction<StaticSegmentFormStateType>>
}

const SegmentContext = createContext({} as SegmentContextType)

const SegmentProvider = (props: any) => {
  const [segmentFormState, setSegmentFormState] = useState<StaticSegmentFormStateType>(defaultStaticSegmentFormState)

  const segmentContextValue: SegmentContextType = {
    segmentFormState,
    setSegmentFormState
  }

  return <SegmentContext.Provider value={segmentContextValue} {...props} />
}

const useSegment = () => React.useContext(SegmentContext)

export { SegmentProvider, useSegment }
